import script from "./InventairePage.vue?vue&type=script&setup=true&lang=js"
export * from "./InventairePage.vue?vue&type=script&setup=true&lang=js"

import "./InventairePage.vue?vue&type=style&index=0&id=751a708c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-751a708c"]])

export default __exports__